import { Button } from "@heroui/react";
import { QuickReplySuggestion } from "../../interfaces/chat.interfaces";

interface ChatSuggestionsProps {
  suggestions: QuickReplySuggestion[];
  onSelect: (value: string) => void;
  disabled?: boolean;
}

export function ChatSuggestions({
  suggestions,
  onSelect,
  disabled,
}: ChatSuggestionsProps) {
  if (!suggestions.length) return null;

  return (
    <div className="flex flex-wrap gap-2 px-4 py-3">
      {suggestions.map((suggestion, index) => (
        <Button
          key={index}
          size="sm"
          variant="bordered"
          className="border-[#159193] text-[#159193] hover:bg-[#159193] hover:text-white"
          onPress={() => onSelect(suggestion.value)}
          isDisabled={disabled}
        >
          {suggestion.label}
        </Button>
      ))}
    </div>
  );
}
